"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDrawGeoJSON = exports.DrawGeoJSON = void 0;
const circle_1 = __importDefault(require("@turf/circle"));
const GeoJSON_1 = __importDefault(require("ol/format/GeoJSON"));
const GeometryType_1 = __importDefault(require("ol/geom/GeometryType"));
const Draw_1 = __importDefault(require("ol/interaction/Draw"));
const proj_1 = require("ol/proj");
const OLSphere = __importStar(require("ol/sphere"));
const react_1 = require("react");
const useOLMap_1 = require("../openlayers/useOLMap");
const GeoJSONFormat = new GeoJSON_1.default({
    dataProjection: 'EPSG:4326',
    featureProjection: 'EPSG:3857',
});
function DrawGeoJSON({ onDraw, type }) {
    useDrawGeoJSON({ type, onDraw });
    return null;
}
exports.DrawGeoJSON = DrawGeoJSON;
function useDrawGeoJSON({ onDraw, type }) {
    const onDrawRef = react_1.useRef(onDraw);
    react_1.useEffect(() => {
        onDrawRef.current = onDraw;
    }, [onDraw]);
    const map = useOLMap_1.useOLMap();
    const interaction = react_1.useMemo(() => {
        return new Draw_1.default({
            type: typeToOlType(type),
        });
    }, [type]);
    react_1.useEffect(() => {
        map.addInteraction(interaction);
        return () => {
            map.removeInteraction(interaction);
        };
    }, [interaction, map]);
    react_1.useEffect(() => {
        const onDraw = (event) => {
            const geom = event.feature.getGeometry();
            if (!geom) {
                return;
            }
            const geoJson = GeoJSONFormat.writeFeatureObject(event.feature);
            if (geoJson && geom.getType() === 'Circle') {
                const circleGeometry = geom;
                const center = circleGeometry.getCenter();
                const radius = circleGeometry.getRadius();
                const edgeCoordinate = [center[0] + radius, center[1]];
                const groundRadius = OLSphere.getDistance(proj_1.transform(center, 'EPSG:3857', 'EPSG:4326'), proj_1.transform(edgeCoordinate, 'EPSG:3857', 'EPSG:4326'), 6378137);
                geoJson.geometry = circle_1.default(proj_1.toLonLat(circleGeometry.getCenter()), groundRadius, {
                    steps: 20,
                    units: 'meters',
                }).geometry;
            }
            onDrawRef.current(geoJson);
        };
        interaction.on('drawend', onDraw);
        return () => {
            interaction.un('drawend', onDraw);
        };
    }, [interaction, map]);
}
exports.useDrawGeoJSON = useDrawGeoJSON;
function typeToOlType(type) {
    switch (type) {
        case 'Polygon':
            return GeometryType_1.default.POLYGON;
        case 'Point':
            return GeometryType_1.default.POINT;
        case 'LineString':
            return GeometryType_1.default.LINE_STRING;
        case 'Circle':
            return GeometryType_1.default.CIRCLE;
    }
}
exports.default = DrawGeoJSON;
//# sourceMappingURL=DrawGeoJSON.js.map